import type { Component } from 'solid-js'
import { z } from 'zod'
import Button from '~/components/Button'
import Form from '~/components/Form'
import Input from '~/components/Input'
import Modal from '~/components/Modal'

export const newClientSchema = z.object({
  name: z.string().trim().min(1, 'El nombre es obligatorio'),
  document: z.string().trim().optional().default(''),
  phone: z.string().trim().optional().default(''),
  address: z.string().trim().optional().default('')
})

export type NewClientValuesType = z.infer<typeof newClientSchema>

export interface NewClientModalPropsType {
  isOpen: boolean
  isSubmitting: boolean
  onClose: () => void
  /** Valores ya validados y convertidos por el esquema del modal. */
  onSubmit: (values: NewClientValuesType) => void | Promise<void>
  /** Subtítulo del modal (dónde se usará el cliente). */
  subtitle?: string
}

/** Alta rápida de un cliente, compartida por cotizaciones y cuentas de cobro. */
const NewClientModal: Component<NewClientModalPropsType> = props => {
  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose} size="sm">
      <Modal.Header>
        <h2 class="text-lg font-bold text-foreground">Nuevo Cliente</h2>
        <p class="text-sm text-foreground-subtle">{props.subtitle ?? 'Se seleccionará en el documento al crearlo'}</p>
      </Modal.Header>
      <Modal.Body>
        <Form
          id="new-client-form"
          validator={newClientSchema}
          initialValues={{ name: '', document: '', phone: '', address: '' }}
          onSubmit={(_formData, values) => props.onSubmit(values as NewClientValuesType)}
        >
          <div class="space-y-4">
            <Input name="name" label="Nombre" required placeholder="Nombre del cliente o empresa" />
            <Input name="document" label="Documento" placeholder="NIT, cédula..." />
            <Input name="phone" label="Teléfono" placeholder="+57 ..." />
            <Input name="address" label="Dirección" placeholder="Ciudad, dirección..." />
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <div class="flex justify-end gap-2">
          <Button type="button" variant="soft" color="default" onClick={props.onClose}>
            Cancelar
          </Button>
          <Button type="submit" form="new-client-form" disabled={props.isSubmitting}>
            {props.isSubmitting ? 'Creando...' : 'Crear cliente'}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

export default NewClientModal
